import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { CheckoutRequest, CheckoutData } from "@/types/topup/checkout";
import type { RouteTicketData, RouteTicketRequest } from "@/types/topup/routeticket";
import type { SummaryRequest, SummaryData } from "@/types/topup/summary";
import type {
  TopupRouteData,
  TopupRouteRequest,
} from "@/types/topup/topuproute";
import type { TopupHistoryRequest, TopupHistoryData } from "@/types/topup/history";
import type { TopupHistoryDetailRequest, TopupHistoryDetailData } from "@/types/topup/historydetail";
import type { TopupPreviewData, TopupPreviewRequest } from "@/types/topup/preview";
import type { DownloadReceiptData, DownloadReceiptRequest } from "@/types/topup/downloadreceipt";

/** Topup Route  */
export async function TopupRoute(payload: TopupRouteRequest) {
  const { data } = await apiClient.post<ApiResponse<TopupRouteData[]>>(
    "/api/AgentTicketInventory/top_up_route_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up route failed");
  }

  return data;
}

/** Topup Route Ticket */
export async function TopupRouteTicket(payload: RouteTicketRequest) {
  const { data } = await apiClient.post<ApiResponse<RouteTicketData[]>>(
    "/api/AgentTicketInventory/route_ticket_detail_topup",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up route ticket failed");
  }

  return data;
}

/** Topup Preview */
export async function TopupPreview(payload: TopupPreviewRequest) {
  const { data } = await apiClient.post<ApiResponse<TopupPreviewData>>(
    "/api/AgentTicketInventory/preview_topup",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up preview failed");
  }

  return data;
}

/** Topup Checkout */
export async function TopupCheckout(payload: CheckoutRequest) {
  const { data } = await apiClient.post<ApiResponse<CheckoutData>>(
    "/api/AgentTicketInventory/checkout_online_payment",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up checkout failed");
  }

  return data;
}

/** Topup Summary */
export async function TopupSummary(payload: SummaryRequest) {
  const { data } = await apiClient.post<ApiResponse<SummaryData>>(
    "/api/AgentTicketInventory/topup_summary",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up summary failed");
  }

  return data;
}

/** Download Receipt */
export async function DownloadReceipt(payload: DownloadReceiptRequest) {
  const { data } = await apiClient.post<ApiResponse<DownloadReceiptData>>(
    "/api/AgentTicketInventory/download_receipt",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get download receipt failed");
  }

  return data;
}

/** Topup History List */
export async function TopupHistory(payload: TopupHistoryRequest) {
  const { data } = await apiClient.post<ApiResponse<TopupHistoryData>>(
    "/api/AgentTicketInventory/topup_history_list",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up history failed");
  }

  return data;
}

/** Topup History Details */
export async function TopupHistoryDetail(payload: TopupHistoryDetailRequest) {
  const { data } = await apiClient.post<ApiResponse<TopupHistoryDetailData>>(
    "/api/AgentTicketInventory/topup_history_detail",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Get top-up history detail failed");
  }

  return data;
}